module.exports = __webpack_public_path__ + "img/34.44bc0d13.png";